import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessaoService } from '../../services/sessao.service';
import { AbstractComponent } from '../../util/abstract.component';

declare var $: any;

@Component({
  selector: 'app-bra-alert-liquidacao',
  templateUrl: './bra-alert-liquidacao.component.html',
  styleUrls: ['./bra-alert-liquidacao.component.css']
})
export class BraAlertLiquidacaoComponent extends AbstractComponent implements OnInit {

  constructor(private sessaoService: SessaoService,
    public dialogRef: MatDialogRef<BraAlertLiquidacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    if (isMobile.matches) {
      $(".mat-dialog-container").css({"width":"80vw","left":"-30%"});
    }
  }

  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-alert-liquidacao/bra-alert-liquidacao.component.ts